import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, AlertTriangle, XCircle } from "lucide-react";

const fmt = (v, format) => {
  if (v == null) return "-";
  if (format === "text") return v;
  if (format === "inr") {
    const abs = Math.abs(v);
    if (abs >= 1_00_00_000) return `${(v / 1_00_00_000).toFixed(1)} Cr`;
    if (abs >= 1_00_000) return `${(v / 1_00_000).toFixed(1)} L`;
    return v.toLocaleString("en-IN");
  }
  if (format === "pct") return `${v}%`;
  if (format === "ratio") return `${v}x`;
  if (format === "days") return `${v} days`;
  if (format === "rating") return `${v}/5.0`;
  if (format === "count") return v.toLocaleString();
  return v;
};

const StatusIcon = ({ value, target, direction }) => {
  if (!target) return null;
  const isGood = direction === "higher" ? value >= target : value <= target;
  const isWarn = direction === "higher" ? value >= target * 0.85 : value <= target * 1.15;
  if (isGood) return <CheckCircle className="w-3.5 h-3.5 text-emerald-500" />;
  if (isWarn) return <AlertTriangle className="w-3.5 h-3.5 text-amber-500" />;
  return <XCircle className="w-3.5 h-3.5 text-red-500" />;
};

const KPIScorecard = ({ scorecard }) => {
  if (!scorecard || scorecard.length === 0) return null;

  return (
    <div className="space-y-4" data-testid="kpi-scorecard">
      {scorecard.map((cat) => (
        <Card key={cat.module} className="card-industrial">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm flex items-center gap-2">
              <span className="w-3 h-3 rounded-full" style={{ backgroundColor: cat.color }} />
              {cat.module}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b bg-muted/30">
                    <th className="text-left p-3 font-medium w-48">KPI</th>
                    <th className="text-right p-3 font-medium">Value</th>
                    <th className="text-center p-3 font-medium w-24">Target</th>
                    <th className="text-center p-3 font-medium w-20">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {cat.metrics.map((m, i) => (
                    <tr key={i} className="border-b hover:bg-muted/20">
                      <td className="p-3 text-muted-foreground">{m.name}</td>
                      <td className="p-3 text-right font-medium">{fmt(m.value, m.format)}</td>
                      <td className="p-3 text-center text-xs text-muted-foreground">
                        {m.target ? `${m.direction === "higher" ? ">" : "<"} ${fmt(m.target, m.format)}` : "-"}
                      </td>
                      <td className="p-3 text-center">
                        {m.target ? (
                          <StatusIcon value={m.value} target={m.target} direction={m.direction} />
                        ) : (
                          <span className="text-xs text-muted-foreground">-</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default KPIScorecard;
